import {PageMap} from '@wix/wixstores-client-core';
import {CustomUrlApi, SiteStore} from '@wix/wixstores-client-storefront-sdk';
import {IWidgetControllerConfig} from '@wix/native-components-infra';
import {ICartProductsManifest} from '../../types/app.types';
import {CartModel} from '../models/Cart.model';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {SPECS} from '../specs';

export class ProductsService {
  private readonly siteStore: SiteStore;
  private readonly customUrlApi: CustomUrlApi;
  private readonly viewerContext: ViewerContext;
  private readonly controllerConfig: IWidgetControllerConfig;

  constructor({
    siteStore,
    viewerContext,
    controllerConfig,
  }: {
    siteStore: SiteStore;
    viewerContext: ViewerContext;
    controllerConfig: IWidgetControllerConfig;
  }) {
    this.siteStore = siteStore;
    this.viewerContext = viewerContext;
    this.controllerConfig = controllerConfig;
    this.customUrlApi = new CustomUrlApi(
      this.viewerContext.isExperimentEnabled(SPECS.MoveCartToViewerContext)
        ? this.controllerConfig.wixCodeApi.location.buildCustomizedUrl
        : siteStore.location.buildCustomizedUrl
    );
  }

  private readonly getHref = (slug: string, useCustomUrl: boolean, sectionUrl: string, pageUrl: string) => {
    if (pageUrl) {
      return pageUrl;
    }
    return useCustomUrl
      ? this.customUrlApi.buildProductPageUrl({slug})
      : /* istanbul ignore next */ `${sectionUrl}/${slug}`;
  };

  public async manifest(cartModel: CartModel): Promise<ICartProductsManifest> {
    const moveCartToViewerContext = this.viewerContext.isExperimentEnabled(SPECS.MoveCartToViewerContext);
    const [useCustomUrl, sectionUrl] = await Promise.all([
      this.customUrlApi.init(),
      moveCartToViewerContext
        ? this.viewerContext.getSectionUrl(PageMap.PRODUCT)
        : this.siteStore.getSectionUrl(PageMap.PRODUCT).then(({url}) => url),
    ]);

    return cartModel.lineItems.reduce<ICartProductsManifest>(
      (acc, lineItem) => ({
        ...acc,
        [lineItem.catalogReference?.catalogItemId]: {
          href: this.getHref(lineItem.url.relativePath, useCustomUrl, sectionUrl, lineItem.url.url),
        },
      }),
      {}
    );
  }
}
